import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import ChatbotUI from './components/ChatbotUI';
import LoginForm from './components/LoginForm';
import MaintenanceScreen from './components/MaintenanceScreen';
import { chatAPI } from './services/apiService';
import { ThemeProvider } from './theme/ThemeContext';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);

  useEffect(() => {
    // Check if user is already authenticated
    const checkAuth = async () => {
      if (chatAPI.isAuthenticated()) {
        try {
          await chatAPI.getCurrentUser();
          setIsAuthenticated(true);
        } catch (error) {
          // Token might be expired, clear it
          chatAPI.logout();
          setIsAuthenticated(false);
        }
      }
      setIsLoading(false);
    };

    checkAuth();
  }, []);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    chatAPI.logout();
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <ThemeProvider>
        <div className="min-h-screen theme-bg-secondary flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 theme-primary mx-auto mb-4" style={{borderBottomColor: 'var(--color-primary)'}}></div>
            <p className="theme-text-secondary">Loading...</p>
          </div>
        </div>
      </ThemeProvider>
    );
  }

  // Show maintenance screen if maintenance mode is enabled
  if (isMaintenanceMode) {
    return (
      <ThemeProvider>
        <MaintenanceScreen />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          {isAuthenticated ? (
            <Routes>
              <Route path="/" element={<ChatbotUI onLogout={handleLogout} />} />
              <Route path="/chat/:sessionId" element={<ChatbotUI onLogout={handleLogout} />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          ) : (
            <Routes>
              <Route path="*" element={<LoginForm onLoginSuccess={handleLoginSuccess} />} />
            </Routes>
          )}
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
